module.exports = __webpack_public_path__ + "img/procedure_03_a.93c836f8.jpg";